import { Megaphone } from "lucide-react";

import type { BannerComponent } from "@src/store/slices/experienceBuilder/types";
import { ModificationListItem } from "@src/features/experienceBuilder/modifications/common/ModificationListItem";
import { stripHTML } from "@src/utils/stripHTML";

export const BannerComponentListItem = ({ mod }: { mod: BannerComponent }) => {
  const subtitle = mod.description || stripHTML(mod.content) || "Empty banner";
  return (
    <ModificationListItem
      mod={mod}
      icon={<Megaphone size={16} />}
      title="Banner component"
      subtitle={subtitle}
    />
  );
};
